module.exports = __webpack_public_path__ + "static/media/logo-horizontal-colored.c004ff60.png";